import {
  BarChart2,
  DollarSign,
  Clock3,
  Images,
  Ruler,
  Users,
  LogOut,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import "./Sidebar.css";

const MENU = {
  DASHBOARD: "DASHBOARD",
  SALES_REPORTS: "SALES_REPORTS",
  SESSIONS: "SESSIONS",
  OUTLET_RADIUS: "OUTLET_RADIUS",
  DISPLAY_PROOFS: "DISPLAY_PROOFS",
  USERS: "USERS",
};

export default function Sidebar({
  activeMenu,
  setActiveMenu,
  user,
  onLogout,
  isOpen = true,
  onClose,
}) {
  const { t } = useTranslation();
  const roleLabel = user?.role === "super_admin" ? t("admin.sidebar.superAdmin") : t("admin.sidebar.admin");
  const userName = user?.full_name || t("admin.sidebar.adminUser");
  const userInitial = userName?.charAt(0)?.toUpperCase() || "A";

  return (
    <>
      <div
        className={`admin-sidebar-overlay ${isOpen ? "admin-sidebar-overlay-open" : ""}`}
        onClick={onClose}
      ></div>

      <aside className={`admin-sidebar ${isOpen ? "admin-sidebar-open" : ""}`}>
      <div className="admin-sidebar-header">
        <BarChart2 size={24} />
        <div className="admin-sidebar-brand">
          <h1>{t("admin.sidebar.brand")}</h1>
          <p>{t("admin.sidebar.portal")}</p>
        </div>
      </div>

      <nav className="admin-nav">
        <button
          className={`admin-nav-item ${activeMenu === MENU.DASHBOARD ? "admin-nav-active" : ""}`}
          onClick={() => setActiveMenu(MENU.DASHBOARD)}
        >
          <BarChart2 size={20} />
          {t("admin.sidebar.dashboard")}
        </button>

        <button
          className={`admin-nav-item ${activeMenu === MENU.SALES_REPORTS ? "admin-nav-active" : ""}`}
          onClick={() => setActiveMenu(MENU.SALES_REPORTS)}
        >
          <DollarSign size={20} />
          {t("admin.sidebar.salesReports")}
        </button>

        <button
          className={`admin-nav-item ${activeMenu === MENU.SESSIONS ? "admin-nav-active" : ""}`}
          onClick={() => setActiveMenu(MENU.SESSIONS)}
        >
          <Clock3 size={20} />
          {t("admin.sidebar.sessions")}
        </button>

        <button
          className={`admin-nav-item ${activeMenu === MENU.OUTLET_RADIUS ? "admin-nav-active" : ""}`}
          onClick={() => setActiveMenu(MENU.OUTLET_RADIUS)}
        >
          <Ruler size={20} />
          {t("admin.sidebar.outletRadius")}
        </button>

        <button
          className={`admin-nav-item ${activeMenu === MENU.DISPLAY_PROOFS ? "admin-nav-active" : ""}`}
          onClick={() => setActiveMenu(MENU.DISPLAY_PROOFS)}
        >
          <Images size={20} />
          {t("admin.sidebar.displayProofs")}
        </button>

        <button
          className={`admin-nav-item ${activeMenu === MENU.USERS ? "admin-nav-active" : ""}`}
          onClick={() => setActiveMenu(MENU.USERS)}
        >
          <Users size={20} />
          {t("admin.sidebar.users")}
        </button>
      </nav>

      <div className="admin-sidebar-footer">
        <div className="admin-user-info">
          <div className="admin-user-avatar">{userInitial}</div>
          <div className="admin-user-details">
            <div className="admin-user-name">{userName}</div>
            <div className="admin-user-role">{roleLabel}</div>
          </div>
        </div>

        <button className="admin-logout-btn" onClick={onLogout}>
          <LogOut size={18} />
          {t("admin.common.logout")}
        </button>
      </div>
      </aside>
    </>
  );
}
